import api from "src/api";
import { ApiPaymentMethods } from "src/constants";

export interface RequestInputType {
  token: string;
  request: PayRequestType;
}

export const checkout = async (token: string): Promise<CheckoutType> => {
  const url = `/checkout/${token}`;
  const { data } = await api.get<CheckoutType>(url);
  return data;
};

export const pay = async (
  token: string | undefined,
  request: CreditCardRequestType,
): Promise<CreditCardCheckoutResponse> => {
  if (!token) {
    throw new Error("Token is required");
  }
  const url = `/checkout/${token}/pay`;
  const { data } = await api.post<CreditCardCheckoutResponse>(url, request);
  return data;
};

export const tokenizer = async (
  token: string | undefined,
  request: TokenizerRequestType,
): Promise<TokenizerResponseType> => {
  if (!token) {
    throw new Error("Token is required");
  }
  const url = `/checkout/${token}/tokenizer_card`;
  const { data } = await api.post<TokenizerResponseType>(url, request);
  return data;
};

export const payOrderCheckout = async ({
  token,
  request,
}: RequestInputType): Promise<
  PixCheckoutResponse | BankSlipCheckoutResponse
> => {
  const url = `/checkout/${token}/pay`;
  const { data } = await api.post<
    PixCheckoutResponse | BankSlipCheckoutResponse
  >(url, request);
  if (request.paymentInstruments[0].type === ApiPaymentMethods.PIX) {
    return data;
  }

  if (request.paymentInstruments[0].type === ApiPaymentMethods.BANK_SLIP) {
    return data;
  }
  return data;
};

export const directDebitPaymentBankList = async (
  token: string | undefined,
): Promise<DirectDebitBankListResponse> => {
  const url = `/checkout/${token}/directdebit/banks`;
  const { data } = await api.get<DirectDebitBankListResponse>(url);
  return data;
};

export const createDirectDebit = async (
  token: string | undefined,
  request: DirectDebitData,
): Promise<DirectDebitAuthorizationResponse> => {
  const url = `/checkout/${token}/directdebit`;
  const { data } = await api.post<DirectDebitAuthorizationResponse>(
    url,
    request,
  );
  return data;
};

export const directDebitPay = async (
  token: string | undefined,
  request: DirectDebitRequestType,
): Promise<CheckoutType> => {
  const url = `/checkout/${token}/pay`;
  const { data } = await api.post<CheckoutType>(url, request);
  return data;
};

export const getPaymentMethodsOptions = async (
  token: string | undefined,
  paymentMethod: AllowedPaymentMethodsType,
): Promise<PaymentMethodsOptionsResponse> => {
  const url = `/checkout/${token}/payment-method/${paymentMethod}`;
  const { data } = await api.get<PaymentMethodsOptionsResponse>(url);
  return data;
};

export const validateAccountData = async (
  token: string,
  request: ValidateAccountDataRequestType,
): Promise<ValidateAccountDataResponseType> => {
  const url = `/checkout/${token}/directdebit/account/validate`;
  const { data } = await api.post<ValidateAccountDataResponseType>(
    url,
    request,
  );
  return data;
};
